import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Func
import { cookieDel } from '../func/cookieEdit';

function* authCheck() {
  const {res, err} = yield call(function () {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    return axios.post(config.apiUri + "authApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  });

  if (res) {
    if (res.data.bool) {
      if (res.data.isAuth) {
        yield put({
          type: "AUTH_SET",
          payload: {
            isAuth: res.data.isAuth,
            ui: res.data.ui,
            uic: res.data.uic,
          }
        });
      }
      else {
        cookieDel('ULPC');
        yield put({
          type: "REDUCER_INIT",
        });
        window.location.href = "https://www.partner-s.net/login/?error_comment=" + encodeURIComponent("ログインできませんでした") + "&redirect=" + encodeURIComponent(window.location.href);
      }
    }
  }

  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

}


const saga = [
  takeLatest('AUTH_CHECK', authCheck),
];

export default saga;
